import {
  SHIKU_CANISTER_ID,
  LEDGER_CANISTER_ID,
} from '../config/icConfig';

// reducer降级
export const combineReducers = (reducerObj) => {
  return (state, action) => {
    return Object.keys(reducerObj).reduce(
      (acc, prop) => ({
        ...acc,
        [prop]: reducerObj[prop](acc[prop], action),
      }),
      state
    )
  }
};

// 默认主模块reducer
export const reducer = (state, action) => {
  switch (action.type) {
    case "setAgentReducer":
      if (state.principal && action.payload.principal) {
        return state
      }
      return {
        ...state,
        ...action.payload
      }
    case 'setProfile':
      return {
        ...state,
        profile: action.profile
      }
    case 'setIcpBalance':
      return {
        ...state,
        icpBalance: action.icpBalance
      }
    case 'setAppWidth':
      window.appType = action.appType;
      window.appWidth = action.appWidth;
      return {
        ...state,
        appWidth: action.appWidth,
        appType: action.appType,
        appSubType: action.appSubType
      }
    case "setUpProfileFg":
      return { ...state, updataProfileFlag: action.payload }
    case "setIsWhitelistAgent":
      return { ...state, isWhitelistAgent: action.isWhitelistAgent }
    case "setShopCards":
      return { ...state, ...action.payload }
    case "setGoldCart":
      {
        let goldCart = action.payload.goldCart;
        localStorage.setItem("goldCart", JSON.stringify(goldCart));
        return { ...state, ...action.payload }
      }
    default:
      return state;
  }
}

// 默认主state
export const state = {
  ICP2USDRate: 0,
  whitelist: [
    SHIKU_CANISTER_ID,
    LEDGER_CANISTER_ID,
  ],
  isWhitelistAgent: false,
  shikuActor: null,
  ledgerActor: null,
  agent: null,
  agentType: null,
  principal: null,
  profile: null,
  logining: false,
  creatorWhiteList: null, // create NFT/Collection 白名单
  myCollectionList: null, // my collection list
  icpBalance: 0, // user icp balance
  appWidth: null, // document app width
  appType: '', // app type, eg: pc | pad | mobile
  artistWhiteList: [], // artist white list
  updataProfileFlag: false,
  userAgent: "Other",
  appSubType: false,
  shopCart: null,
  goldCart: localStorage.getItem("goldCart") ? JSON.parse(localStorage.getItem("goldCart")) : [],
  kycLevel: "NA",
  kycPending: false,
  kycForm: null
};
